import { Subdimensiones } from "../../../interfaces/Evaluations";

export const allYears = (evaluation_subDimension: Subdimensiones[]) => Array.from(
    new Set(
        evaluation_subDimension.flatMap((row) =>
            row.evaluaciones ? Object.keys(row.evaluaciones) : []
        )
    )
).sort((a, b) => parseInt(b) - parseInt(a));

const extractLawNumber = (s?: string | null): number => {
    if (!s) return Number.NEGATIVE_INFINITY;
    const matches = s.match(/\d+(?:[.,]\d+)*/g);
    if (!matches) return Number.NEGATIVE_INFINITY;
    return Math.max(...matches.map(m => parseInt(m.replace(/[.,]/g, ""), 10)));
};

const bucket = (s?: string) => {
    const t = (s || "").toLowerCase();
    if (!/\d/.test(t) && !t.includes("constitución") && !t.includes("sin ley")) return 0; // Ley de prueba / QA
    if (t.includes("constitución")) return 1;  // Constitución
    if (/\d/.test(t)) return 2;               // Leyes numéricas
    if (t.includes("sin ley")) return 3;      // Sin ley
    return 4; // fallback (por si acaso)
};


// Función para obtener las leyes de cada año en orden descendente
export const allLawsByYear = (evaluation_subDimension: Subdimensiones[], year: string) => {
    const laws = new Map<string, { law: string; url: string | null }>();

    evaluation_subDimension.forEach((row) => {
        row.evaluaciones?.[year]?.forEach((evaluation) => {
            laws.set(evaluation.nombre, { law: evaluation.nombre, url: evaluation.url || null });
        });
    });

    return Array.from(laws.values()).sort((a, b) => {
        const ba = bucket(a?.law);
        const bb = bucket(b?.law);
        if (ba !== bb) return ba - bb;

        if (ba === 2) {
            const na = extractLawNumber(a?.law);
            const nb = extractLawNumber(b?.law);
            if (na !== nb) return nb - na;
        }

        return (b?.law || "").localeCompare(a?.law || "");
    });

};


export const hasValidEvaluation = (subdimension: Subdimensiones): boolean => {
    if (!subdimension?.evaluaciones) return false;

    return Object.values(subdimension.evaluaciones).some((evaluaciones) =>
        evaluaciones.some(
            (ev) => ev.evaluacion === "Cumple" || ev.evaluacion === "Restringe"
        )
    );
};